module.exports = {
    PLAYER: 2,
    HOST: 0,
    IMPROVISER: 1,
    DEV: 3,
    SYSTEM: 4
}


// WEBPACK FOOTER //
// ./src/models/Roles.js